import { JSX } from 'react';
import { ToggleListItem } from '@bg-components/Modals/TopSettingsModal/List/ToggleListItem';
import { useStore } from '@betgames/bg-state-manager';
import { uaParser } from '@betgames/bg-tools';
import {
    t,
    soundsStore,
    soundsSelectors,
    videoStreamSelectors,
    videoStreamStore,
    iosSoundHandlerStore,
    analyticsApi,
    playerSettingsStore,
    playerSettingsSelectors,
} from '@bg-shared';

export const StudioSounds = (): JSX.Element => {
    const studioSoundsMuted = useStore(soundsStore, soundsSelectors.getStudioSoundsMuted);
    const isGuiMode = useStore(playerSettingsStore, playerSettingsSelectors.getGuiMode);
    const videoReady = useStore(videoStreamStore, videoStreamSelectors.getReady);

    // on iOS browser user can enable sounds only when video is ready
    if (uaParser.isIOS && !videoReady) {
        return null;
    }

    return (
        <ToggleListItem
            disabled={isGuiMode}
            label={t.string('studio_sounds')}
            enabled={!studioSoundsMuted}
            dataQa="area-toggle-studio-sounds-list-item"
            onChange={(newValue) => {
                soundsStore.studioSoundsMuted = !newValue;
                iosSoundHandlerStore.autoDisabled = false;
                analyticsApi.trackStudioSoundSettingSwitch(newValue);
            }}
        />
    );
};
